module.exports = __webpack_public_path__ + "img/join-06.8378221d.jpg";